var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', {
    staticClass: "table-wrapper"
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "id": "table",
      "responsive": "",
      "small": "",
      "items": _vm.getCurrentEventFlowItems,
      "fields": _vm.getFields
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function (data) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(_vm._s(data.label))])];
      }
    }, {
      key: "head(details)",
      fn: function () {
        return [_vm.hasDetailedItems ? _c('div', {
          staticClass: "pointer nowrap",
          on: {
            "click": _vm.toggleAll
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.show-all-details')) + " "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.toggled,
            expression: "!toggled"
          }],
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_down.svg")
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.toggled,
            expression: "toggled"
          }],
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_up.svg")
          }
        })]) : _c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.show-all-details')) + " ")])];
      },
      proxy: true
    }, {
      key: "cell(brief)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "nowrap brief"
        }, [_vm._v(" " + _vm._s(row.item.brief) + " ")])];
      }
    }, {
      key: "cell(startedAt)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.formatToTime(row.item.startedAt)) + " ")])];
      }
    }, {
      key: "cell(endedAt)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.formatToTime(row.item.endedAt)) + " ")])];
      }
    }, {
      key: "cell(totalTime)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s(_vm.differenceInTime(row.item.endedAt, row.item.startedAt)) + " ")])];
      }
    }, {
      key: "cell(locationName)",
      fn: function (row) {
        var _row$item$location;
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s((_row$item$location = row.item.location) === null || _row$item$location === void 0 ? void 0 : _row$item$location.name) + " ")])];
      }
    }, {
      key: "cell(topic)",
      fn: function (row) {
        var _row$item$topic;
        return [_c('span', {
          staticClass: "nowrap"
        }, [_vm._v(" " + _vm._s((_row$item$topic = row.item.topic) === null || _row$item$topic === void 0 ? void 0 : _row$item$topic.name) + " ")])];
      }
    }, {
      key: "cell(responsible)",
      fn: function (row) {
        var _row$item$responsible, _row$item$responsible2;
        return [row.item.responsible ? _c('span', {
          staticClass: "nowrap"
        }, [_c('div', {
          staticClass: "responsible-wrapper"
        }, [_c('div', {
          staticClass: "little-circle",
          style: `background-color:${(_row$item$responsible = row.item.responsible) === null || _row$item$responsible === void 0 ? void 0 : _row$item$responsible.color}`
        }), _vm._v(" " + _vm._s((_row$item$responsible2 = row.item.responsible) === null || _row$item$responsible2 === void 0 ? void 0 : _row$item$responsible2.name) + " ")])]) : _vm._e()];
      }
    }, {
      key: "cell(details)",
      fn: function (row) {
        return [_vm.hasDescription(row.item) ? _c('div', {
          staticClass: "details"
        }, [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !row.detailsShowing,
            expression: "!row.detailsShowing"
          }],
          staticClass: "pointer",
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_down.svg")
          },
          on: {
            "click": row.toggleDetails
          }
        }), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: row.detailsShowing,
            expression: "row.detailsShowing"
          }],
          staticClass: "pointer",
          attrs: {
            "src": require("@/assets/event-flow-table/arrow_up.svg")
          },
          on: {
            "click": row.toggleDetails
          }
        })]) : _vm._e()];
      }
    }, {
      key: "row-details",
      fn: function (row) {
        return [_c('div', {
          staticClass: "text text-justify"
        }, [_c('div', {
          staticClass: "long-description"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.table.long-description')) + " ")]), _c('div', [_vm._v(_vm._s(row.item.description))])])];
      }
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }